import { render, staticRenderFns } from "./CardTransferencia.vue?vue&type=template&id=55b37150&"
import script from "./CardTransferencia.vue?vue&type=script&lang=js&"
export * from "./CardTransferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports